export default function selectCompanieById(companies, value) {
  if (!companies) return;
  for (let i = 0; i < companies.length; i++) {
    if (value === companies[i].companieId) {
      return companies[i];
    }
  }
}


// move to selectors
